/**
 * Picker de dias da semana — botoes pill (Seg, Ter, ..., Dom).
 * 0 = Domingo, 1 = Segunda, ..., 6 = Sabado.
 */

const DAYS: { id: number; label: string }[] = [
  { id: 1, label: "Seg" },
  { id: 2, label: "Ter" },
  { id: 3, label: "Qua" },
  { id: 4, label: "Qui" },
  { id: 5, label: "Sex" },
  { id: 6, label: "Sab" },
  { id: 0, label: "Dom" },
];

interface Props {
  value: number[];
  onChange: (next: number[]) => void;
}

export function WeekdayPicker({ value, onChange }: Props) {
  const toggle = (id: number) => {
    if (value.includes(id)) onChange(value.filter((v) => v !== id));
    else onChange([...value, id].sort());
  };

  return (
    <div className="flex flex-wrap gap-2.5">
      {DAYS.map((d) => {
        const active = value.includes(d.id);
        return (
          <button
            key={d.id}
            type="button"
            onClick={() => toggle(d.id)}
            className={`h-11 min-w-[80px] rounded-xl px-5 text-sm font-semibold transition-colors ${
              active
                ? "bg-primary-600 text-white shadow-sm"
                : "border border-border bg-card text-foreground hover:bg-muted"
            }`}
          >
            {d.label}
          </button>
        );
      })}
    </div>
  );
}
